import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { clickElement, generateDynamicColumnStyles, navigation1, navigation3 } from '../../../common/helper'
import FrnDetailedTblNew from './FrnDetailedTblNew'
import FrnSummaryTable from './FrnSummaryTable'
import moment from 'moment'
import { summaryColDefs, headerColDefsExcel } from './Constants'
import { exportToExcel } from '../../../common/hook'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { useDispatch } from 'react-redux'
import { FranchiseeSettlementUpdateData } from '../../../../store/reports/reports_action'
import { updateAlertError } from '../../../../store/common/common_action'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'

const FranchiseeSettlementViewTables = (props) => {
    const {
        filters, loginData, Table1,
        reportData ,
        originalData ,
        allownFormatLR,
        columns, excelColumns,
        summaryReportData ,
    } = props
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const dispach = useDispatch()
    const [selectAllLR, setSelectAllLR] = useState(false)
    const [selectedData, setSelectedData] = useState([])
    const [isSuccess, setIsSuccess] = useState(false)
    const [tableData, setTableData] = useState([]);
    const [summaryData, setSummaryData] = useState([])

    const currentDateTime = moment(new Date()).format('DD-MMM-YYYY HH:mm')
    const reportName = 'Franchisee Settlement Report'
    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Date', textAlign: 'left' },
        { field: 'fromCompany', header: 'From Company', textAlign: 'left' },
        { field: 'fromBranch', header: 'From Branch', textAlign: 'left' },
        { field: 'franchisee', header: 'Franchisee', textAlign: 'left' },
        { field: 'franchiseeBranch', header: 'Franchisee Branch', textAlign: 'left' },
        { field: 'status', header: 'Status', textAlign: 'left' },
    ]
    const criteriaData = {
        fromDate: moment(filters?.fromDate).format('DD-MM-YYYY'),
        toDate: moment(filters?.toDate).format('DD-MM-YYYY'),
        fromCompany: filters?.fromCompany?.CompanyName,
        fromBranch: filters?.fromBranch?.BranchName,
        franchisee: filters?.franchisee?.CompanyName,
        franchiseeBranch: filters?.franchiseeBranch?.BranchName,
        status: filters?.status?.name,
        dataType: 'entry',
    }
    useEffect(() => {
        if (reportData?.length) {
            setTableData(reportData||[])
        }
    }, [reportData])
     useEffect(() => {
        if (summaryReportData?.length) {
            setSummaryData(summaryReportData||[])
        }
    }, [summaryReportData])
    const generatePDF = () => {
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
        const doc = new jsPDF({ orientation: 'l', format: [1680, 1187], unit: 'px', compress: true })

        doc.autoTableSetDefaults({
            headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
        })
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, 'right')
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${loginData.strUserName} [ ${loginData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 -
                (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5
            )
        }
        doc.setProperties({
            title: `Franchisee Settlement Report.pdf`,
            subject: 'Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Franchisee Settlement Report',
            creator: 'MTLPL',
        })
        const HeaderData = [
            {
                fromCompany: filters?.fromCompany?.CompanyName,
                fromBranch: filters?.fromBranch?.BranchName,
                franchisee: filters?.franchisee?.CompanyName,
                franchiseeBranch: filters?.franchiseeBranch?.BranchName,
                status: filters?.status?.name,
            },
        ]
        const pdfHeaderCol = headerColDefsExcel?.filter((item) => item?.dataKey !== 'fromDate' && item?.dataKey !== 'toDate')
        const bodyData = tableData?.flatMap((item) => {
            if (item.isSubHeading) {
                // Modify the toPayData items and return the subheading item along with the modified toPayData
                const modifiedToPayData = item.toPayData.map((data) => ({
                    ...data,
                    IsReceived: data.IsReceived === 1 ? 'Yes' : data.IsReceived === 0 ? 'No' : '' // Change IsReceived property
                }));

                return [item, ...modifiedToPayData]; // Return the item and the modified toPayData
            }
        });
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 30, bottom: 0 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfHeaderCol,
            body: HeaderData,
            columnStyles: {
                0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
            },
            theme: 'grid',
            showHead: 'everyPage',
            headStyles: {
                halign: 'left',
                valign: 'middle',
                cellPadding: 12,
                fontSize: 14,
                minCellHeight: 36,
                fillColor: [182, 222, 254],
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                font: 'Roboto',
                lineWidth: 0.6,
            },
        })
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            startY: doc.lastAutoTable.finalY + 24,
            columns: excelColumns,
            body: bodyData,
            columnStyles: generateDynamicColumnStyles(excelColumns, 14),
            // showHead: 'repeat',
            theme: 'grid',
            styles: {
                fontSize: 14,
                lineWidth: [0, 0.6, 0, 0.6],
                fontStyle: 'bold',
            },
            tableLineWidth: 0.6,
            headStyles: {
                fontSize: 14,
                fillColor: [182, 222, 254],
                textColor: [0, 0, 0],
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'bold',
                font: 'Roboto',
            },
            didParseCell: (data) => {
                if (data.row.section === 'head' || data.row.section === 'body') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
                if (data.row.raw.isSubHeading) {
                    data.row.cells[0].colSpan = excelColumns?.length;
                }
            },
            willDrawCell: (data) => {
                if (data.row.raw.isSubHeading) {
                    doc.setFillColor(218, 237, 254);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';
                    data.cell.colSpan = excelColumns?.length
                } else if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';
                }
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Report Date : ${moment(filters?.fromDate).format('DD-MMM-YYYY')} To ${moment(filters?.toDate).format('DD-MMM-YYYY')}`, 30, 145)
                doc.setFontSize(16)
                doc.setFont('Roboto', 'bold')
                doc.text(`Report:Franchisee Settlement Report`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(20).setFont('Roboto', 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Accounting Reports', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(20).setFont('Roboto', 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 700, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            startY: doc.lastAutoTable.finalY + 24,
            columns: summaryColDefs,
            body: summaryData,
            columnStyles: {
                0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 188, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 188, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
            },
            // showHead: 'repeat',
            theme: 'grid',
            styles: {
                fontSize: 14,
                lineWidth: [0, 0.6, 0, 0.6],
                fontStyle: 'bold',
            },
            tableLineWidth: 0.6,
            headStyles: {
                fontSize: 14,
                fillColor: [182, 222, 254],
                textColor: [0, 0, 0],
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'bold',
                font: 'Roboto',
            },
            didParseCell: (data) => {
                if (data.row.section === 'head' || data.row.section === 'body') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
            },
            willDrawCell: (data) => {
                if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';
                }
            },

        })
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // Open the PDF in a new tab
        window.open(pdfUrl);
    }
    const handleSelectAllLR = (e) => {
        let newData = [...tableData];
        const isChecked = e.target.checked;
        const intCompanyID = loginData?.intCompanyID
        let Count = 0
        newData.forEach((item) => {
            item.toPayData.forEach((row) => {
                if (!row.isTotalRow) {
                    let condition = ((row.receiveValue == "Paid" || row.VehicleCompanyID != intCompanyID || row.HasReceivedAtBranch == 0) || (row.CompanyID == row.VehicleCompanyID && row.CompanyID == intCompanyID))
                    if (!condition) {
                        row.receive = isChecked ? 1 : 0;
                        Count++;
                    } else {
                        row.receive = row?.IsReceived
                    }
                }
            });
        });
        if (Count > 0) {
            setTableData(newData);
            setSelectAllLR(isChecked);

            if (isChecked) {
                // If checked, add all rows to selectedData
                const allRows = newData.flatMap(item => item.toPayData); // Flatten the toPayData arrays
                const newSelectedData = allRows.filter(row => !row.isTotalRow); // Assuming each row has a unique 'BookingID'
                setSelectedData(newSelectedData); // Set selectedData to all rows
            } else {
                // If unchecked, clear selectedData
                setSelectedData([]); // Clear selectedData
            }
        }
    }
    const handleUpdate = () => {
        if (selectedData?.length <= 0) {
            updateAlertError({ show: true, msg: 'Please Select Atleast One Row For Updating', nextId: '' })
            return
        } else {
            let body = {
                UserID: loginData?.intUserID,
                ChallanCompanyIDs: selectedData.map(row => row.CompanyID).join('^'),
                ChallanNos: selectedData.map(row => row.ChallanNo).join('^'),
                Remarks: selectedData.map(row => row.remarks).join('^'),
            }
            dispach(FranchiseeSettlementUpdateData(body)).then((res) => {
                if (res.status === 'Success') {
                    setIsSuccess(true)
                } else {
                    dispach(updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' }))
                    return
                }
            }).catch((err) => {
                console.log('Error:', err)
            })
        }
    }
    const flattenGroupedData = (groupedData = []) => {
        const result = [];

        groupedData.forEach(group => {
            const { toPayData = [], ...subHeader } = group;

            const subHeaderRow = {
                ...subHeader,
                dataType: "subHeader",
                align: { GeneratedDateTime: 'left' },
                colSpan: { GeneratedDateTime: 6 }
            };

            result.push(subHeaderRow);

            const toPayRows = toPayData.map(val => ({
                ...val,
                dataType: val.isDataRow ? 'entry' : 'total'
            }));

            result.push(...toPayRows);
        });

        return result;
    };
    const headersList = [];
    const dataList = [];

    // 1️⃣ Report Header
    headersList.push([
        { field: 'reportName', header: `Report Name: ${reportName}` },
        { field: 'companyName', header: `Company Name: ${loginData?.strCompanyName || ''}` }
    ]);
    dataList.push([{}]);

    // 2️⃣ Criteria
    headersList.push(criteriaHeaders);
    dataList.push([criteriaData]);

    // 3️⃣ Detailed Table
    const detailedMainHeader = columns.map(col => ({
        field: col.dataKey,
        header: col.exportHead?.replace(/\n/g, ' '),
        textAlign: col.align,
    }));

    headersList.push(detailedMainHeader);
    dataList.push(flattenGroupedData(tableData));

    // 4️⃣ Summary Table
    const summaryMainHeader = summaryColDefs.map(col => ({
        field: col.dataKey,
        header: col.header,
        textAlign: col.headerSx?.textAlign,
    }));

    headersList.push(summaryMainHeader);
    dataList.push(
        summaryData?.map(val => ({
            ...val,
            dataType: val.isTotalRow ? 'total' : 'entry'
        })) || []
    );


    return (
        <>
            <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', padding: '10px 0px 0px 0px' }}>
                <Box
                    style={{
                        display: 'flex',
                        width: '50%',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: '12px',
                        fontSize: '14px',
                    }}
                >
                    <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '22px' }}>
                        Report For: Franchisee Settlement Report
                    </h3>
                </Box>
                <Box
                    className="reportButton"
                    style={{
                        display: 'flex',
                        width: '50%',
                        justifyContent: 'end',
                        alignItems: 'center',
                        paddingRight: '22px',
                        gap: '16px',
                    }}
                > <Item sx={{ ...sx.itemsx, right: 0 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id="selectAll"
                                    checked={selectAllLR}
                                    disabled={tableData?.length === 0}
                                    onChange={handleSelectAllLR}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'update_btn', 'refreshBtn')
                                    }}
                                />
                            }
                            label="Select All Unpaid LRs"
                        />
                    </Item>

                    <Button
                        variant="contained"
                        onKeyDown={(e) =>
                            navigation3(e, 'excelBtn', 'selectAll', () => {
                                handleUpdate()
                            })
                        }
                        id="update_btn"
                        sx={{ width: '100px', padding: '6px !important', fontSize: '14px !important' }}
                        className="btn btn-primary"
                        disabled={tableData?.length === 0}
                        onClick={() => {
                            handleUpdate()
                        }}
                    >
                        Update
                    </Button>
                    <Item sx={{ ...sx.itemsx }} className="">
                        <Button
                            variant="outlined"
                            color="secondary"
                            id="excelBtn"
                            sx={{ width: '100%' }}
                            className="receiveitembtn"
                            onClick={() => {
                                exportToExcel({
                                    fileName: `${reportName} ${currentDateTime}.xlsx`,
                                    sheetName: reportName,
                                    headersList,
                                    dataList,
                                });
                            }}
                            onKeyDown={(e) => navigation1(e, 'print', 'memeoShortPrint')}
                        >
                            Export To Excel
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx }} className="">
                        <Button
                            id="print"
                            variant="outlined"
                            className="receiveitembtn"
                            onClick={() => {
                                generatePDF()
                            }}
                            onKeyDown={(e) => {
                                navigation1(e, 'fromDate', 'excelBtn')
                            }}
                        >
                            Export To PDF
                        </Button>
                    </Item>
                </Box>
            </Box>

            <FrnDetailedTblNew
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                tableData={tableData}
                setTableData={setTableData}
                loginData={loginData}
                originalData={originalData}
                // groupTables={groupTables}
                allownFormatLR={allownFormatLR}
                columns={columns}
                excelColumns={excelColumns}
                Table1={Table1}
            // convertToInt32={convertToInt32}
            />
            <FrnSummaryTable tableData={summaryData} setTableData={setSummaryData} />
            <SuccessAndErrorModal
                handleClose={() => {
                    setIsSuccess(false);
                    //   handleClick1()
                }} open={isSuccess} title={`Updated Successfully`} modalStyle={modalStyle} />
        </>
    )
}

export default FranchiseeSettlementViewTables
